(function (angular) {
    "use strict";
    var fmgApp = angular.module('common-services');

    //This controller handles redirection if you land at the root of the site. e.g. http://productsuite.com/
    //and takes you to the LauncherApp - if logged in, you go to the Product List Page, if not logged in, logout is called
    //to ensure no invalid token has been saved, and then auto redirect you to the Loginpage.
    fmgApp.controller('RedirectionController', function ($scope,authenticationService,$state) {

        $scope.OnInit = function(){
            if(authenticationService.isLoggedIn() === true){
                $state.go('list');
            }else{
                authenticationService.logout();
            }
        };
    });
})(window.angular);